import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router';
import DetailedProduct from '../Components/ProductPage/DetailedProduct';
import WebData from '../Helpers/WebData'
import "./ProductPage.css";

function ProductPage() {

    const {productName} = useParams();

    const [product, setProduct] = useState();

    useEffect(() => {
        const product_name = productName.split("_").join(" ");
        setProduct(WebData.products.find(({name}) => name === product_name));
    }, [productName]);

    return (
        <div className="product-page">
            {
                product? <DetailedProduct product={product}/> : (
                    <div className="d-flex align-content-center justify-content-center">
                        <h2>Product not found</h2>
                    </div>
                )
            }
        </div>
    )
}

export default ProductPage
